import React, { useEffect, useState } from "react";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useMutateUpdateSettingsDetails } from "../hooks/useApihook";
import { useQuery } from "@tanstack/react-query";
import { GetSettingsDetails } from "../../../../Api/setting";

const OpenApplicationMaintenance = () => {
    const updateSettingsMutation = useMutateUpdateSettingsDetails();
    const [isOpen, setIsOpen] = useState(false);

    const { data: settingsData } = useQuery({
        queryKey: ["get-settings-details", "openApplicationMaintenance"],
        queryFn: () => GetSettingsDetails("openApplicationMaintenance"),
        throwOnError: true,
        onError: (error) => {
            ErrorToast(
                error?.response?.data?.message || error?.message || "Server Error."
            );
        },
    });

    useEffect(() => {
        if (settingsData) {
            setIsOpen(settingsData?.data?.openApplicationMaintenance || false);
        }
    }, [settingsData]);

    const handleToggle = () => {
        const newValue = !isOpen;
        const reqData = {
            name: "openApplicationMaintenance",
            details: {
                openApplicationMaintenance: newValue,
            },
        };

        updateSettingsMutation.mutate(reqData, {
            onSuccess: (response) => {
                SuccessToast(response.message || "Application maintenance setting updated successfully.");
                setIsOpen(newValue);
            },
            onError: (error) => {
                ErrorToast(error?.response?.data?.message || "Server Error.");
            },
        });
    };

    return (
        <div className="setting-border">
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-info" role="alert">
                        Toggle this switch to enable or disable application maintenance mode.
                    </div>
                    <div className="d-flex align-items-center justify-content-between p-3 border rounded">
                        <div>
                            <h5 className="mb-0">Application Maintenance</h5>
                            <small className="text-muted">
                                {isOpen ? "Maintenance mode is currently ON" : "Maintenance mode is currently OFF"}
                            </small>
                        </div>
                        <div className="form-check form-switch custom-switch-lg">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="maintenanceSwitch"
                                checked={isOpen}
                                onChange={handleToggle}
                                style={{ cursor: "pointer", width: "3em", height: "1.5em" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpenApplicationMaintenance;
